// extracted by mini-css-extract-plugin
export default {"container":"app-shifts-ShiftEdit-ShiftEdit-module__mNJqf3mmSUVQt2qSn0I2","button":"app-shifts-ShiftEdit-ShiftEdit-module__wCunSsaX0ahNVxagh2Jj"};